import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '@core/services';
import { environment } from '../environments/environment';
import { AuthDataSitterDialogComponent } from './core/components/AuthDataSitterDialog/AuthDataSitterDialog.component';
import { LoaderComponent } from './core/components/loader/loader.component';
import { ToasterComponent } from './core/components/toaster/toaster.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    LoaderComponent,
    ToasterComponent,
    CommonModule,
    AuthDataSitterDialogComponent,
  ],
  templateUrl: './app.component.html',
})
export class AppComponent {
  readonly #authService = inject(AuthService);
  isStandAlonePortal = signal(environment.isStandalonePortal);

  title = 'bc-bi-ui';

  showAuthDataSitterDialog = this.#authService.showAuthDataSitterDialog;

  constructor() {
    (window as any).versionDate = environment.versionDate;
  }
}
